//combine all reducers (slices)
import { combineReducers } from "redux";
import organizationSlice from "./organisationSlice";
import headerSlice from "./headerSlice";
import userSlice from "./userSlice";
import packageSlice from "./packageSlice";
import environmentSlice from "./environmentSlice";
import vfuserSlice from "./vfuserSlice";
import overlaySlice from "./overlaySlice";
import translationSlice from "./translationSlice";

export default combineReducers({
  header: headerSlice,
  organization: organizationSlice,
  user: userSlice,
  package: packageSlice,
  environment: environmentSlice,
  vfuser: vfuserSlice,
  overlay: overlaySlice,
  translation: translationSlice,
});
